/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import axios from "axios";
import config from "../../config";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import "./ReportingDashboard.css";

class ReportingAnalysis extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parameters: [],
            reportTypes: [
                "All Reports",
                "By Operating Unit",
                "By Month (YTD)",
                "By Water Type",
            ],
            selectedParameter: "",
            selectedReport: "All Reports",
            financialYear: "FY 2025-2026",
            result: null,
            loading: false,
            analyzing: false,
            chartLoading: false,
            error: "",
        };
    }

    componentDidMount() {
        this.fetchParameters();
    }

    // 🔹 Fetch Parameters
    fetchParameters = async () => {
        try {
            const cardId = this.props.match?.params?.id || 1;
            this.setState({ loading: true, error: "" });

            const response = await axios.get(
                `${config.laravelBaseUrl}reporting-dashboard/parameter-units`,
                {
                    params: { card_id: cardId },
                    headers: {
                        Authorization: "Bearer " + sessionStorage.getItem("userToken"),
                    },
                }
            );

            if (response.data?.success) {
                const { parameters = [] } = response.data.data;
                this.setState({ parameters, loading: false });
            } else {
                this.setState({
                    error: response.data?.message || "Failed to fetch parameters.",
                    loading: false,
                });
            }
        } catch (err) {
            console.error("Error fetching parameters:", err);
            this.setState({ error: "Failed to fetch parameters.", loading: false });
        }
    };

    // 🔹 Trigger Analysis
    handleAnalyze = async () => {
        const { selectedParameter, selectedReport, financialYear } = this.state;

        if (!selectedParameter || !financialYear || !selectedReport) {
            alert("Please select all required fields before analysis.");
            return;
        }

        try {
            this.setState({ analyzing: true, chartLoading: true, result: null, error: "" });

            const response = await axios.post(
                `${config.laravelBaseUrl}reporting-dashboard/analyze`,
                {
                    card_id: this.props.match?.params?.id || 1,
                    parameter_id: selectedParameter,
                    report_type: selectedReport,
                    financial_year: financialYear,
                },
                {
                    headers: {
                        Authorization: "Bearer " + sessionStorage.getItem("userToken"),
                    },
                }
            );

            setTimeout(() => this.setState({ chartLoading: false }), 700);

            if (response.data?.success) {
                this.setState({ result: response.data.data, analyzing: false });
            } else {
                this.setState({
                    analyzing: false,
                    error: response.data?.message || "Analysis failed.",
                });
            }
        } catch (err) {
            console.error("Analysis error:", err);
            this.setState({ analyzing: false, chartLoading: false, error: "Analysis failed." });
        }
    };

    // 🔹 Render Filters
    renderFilters = () => {
        const {
            parameters,
            selectedParameter,
            reportTypes,
            selectedReport,
            financialYear,
        } = this.state;

        return (
            <div className="card shadow-sm rounded-lg border-0 p-4 mb-4">
                <h5 className="font-weight-bold text-primary mb-3">Analysis Filters</h5>
                <div className="row align-items-end">
                    <div className="col-md-4 mb-3">
                        <label className="font-weight-bold small text-muted">Parameter</label>
                        <select
                            className="form-control form-control-sm"
                            value={selectedParameter}
                            onChange={(e) => this.setState({ selectedParameter: e.target.value })}
                        >
                            <option value="">Select Parameter</option>
                            {parameters.map((p) => (
                                <option key={p.id} value={p.id}>
                                    {p.data_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="font-weight-bold small text-muted">Report Type</label>
                        <select
                            className="form-control form-control-sm"
                            value={selectedReport}
                            onChange={(e) => this.setState({ selectedReport: e.target.value })}
                        >
                            {reportTypes.map((r) => (
                                <option key={r} value={r}>
                                    {r}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-3 mb-3">
                        <label className="font-weight-bold small text-muted">
                            Financial Year
                        </label>
                        <select
                            className="form-control form-control-sm"
                            value={financialYear}
                            onChange={(e) => this.setState({ financialYear: e.target.value })}
                        >
                            <option>FY 2024-2025</option>
                            <option>FY 2025-2026</option>
                        </select>
                    </div>

                    <div className="col-md-1 mb-3 text-right">
                        <button
                            style={{ background: "#1232c3" }}
                            className="btn btn-primary btn-sm shadow-sm px-3 w-100"
                            onClick={this.handleAnalyze}
                            disabled={this.state.analyzing}
                        >
                            {this.state.analyzing ? (
                                <i className="fas fa-spinner fa-spin"></i>
                            ) : (
                                <i className="fas fa-chart-bar"></i>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // 🔹 Render Charts (handles single vs multiple layouts)
    renderCharts = () => {
        const { result, chartLoading } = this.state;
        if (!result || !result.data?.length) return null;

        const colorPalette = [
            "rgba(54, 162, 235, 0.8)",
            "rgba(255, 159, 64, 0.8)",
            "rgba(75, 192, 192, 0.8)",
        ];

        const isSingle = result.data.length === 1;

        return (
            <div className="position-relative">
                {chartLoading && (
                    <div className="chart-loader position-absolute w-100 h-100 d-flex align-items-center justify-content-center">
                        <div className="spinner-border text-primary" role="status"></div>
                    </div>
                )}

                <div className={`row ${isSingle ? "justify-content-center" : ""}`}>
                    {result.data.map((section, index) => {
                        const labels = section.data.map((d) => d.category);
                        const values = section.data.map((d) => d.value);
                        const barCount = labels.length;

                        const chartData = {
                            labels,
                            datasets: [
                                {
                                    label: `${section.label} (${section.data[0]?.unit})`,
                                    data: values,
                                    backgroundColor: (ctx) => {
                                        const gradient = ctx.chart.ctx.createLinearGradient(0, 0, 0, 300);
                                        gradient.addColorStop(0, colorPalette[index % colorPalette.length]);
                                        gradient.addColorStop(1, "rgba(255,255,255,0.3)");
                                        return gradient;
                                    },
                                    borderColor: colorPalette[index % colorPalette.length].replace(
                                        "0.8",
                                        "1"
                                    ),
                                    borderWidth: 1.5,
                                    hoverBorderWidth: 2.5,
                                    hoverBackgroundColor: colorPalette[index % colorPalette.length].replace(
                                        "0.8",
                                        "0.9"
                                    ),
                                    barThickness: barCount === 1 ? 40 : 20,
                                },
                            ],
                        };

                        const chartOptions = {
                            responsive: true,
                            maintainAspectRatio: false,
                            animation: {
                                duration: 1000,
                                easing: "easeOutCubic",
                            },
                            plugins: {
                                legend: {
                                    display: true,
                                    position: "top",
                                    labels: {
                                        color: "#333",
                                        boxWidth: 14,
                                        font: { size: 13 },
                                    },
                                },
                                tooltip: {
                                    backgroundColor: "#000000cc",
                                    padding: 10,
                                    titleFont: { size: 13, weight: "bold" },
                                    bodyFont: { size: 12 },
                                    callbacks: {
                                        label: (ctx) =>
                                            `${ctx.dataset.label}: ${ctx.parsed.y.toLocaleString()}`,
                                    },
                                },
                            },
                            scales: {
                                x: {
                                    title: { display: true, text: "Category" },
                                    ticks: { color: "#555", font: { size: 11 } },
                                    grid: { display: false },
                                },
                                y: {
                                    beginAtZero: true,
                                    title: { display: true, text: "Value" },
                                    ticks: { color: "#555", font: { size: 11 } },
                                    grid: { color: "#eee" },
                                },
                            },
                        };

                        return (
                            <div
                                key={index}
                                className={isSingle ? "col-lg-8 col-md-10 col-sm-12 mb-4" : "col-md-6 col-lg-4 mb-4"}
                            >
                                <div
                                    className="card shadow-sm border-0 rounded-lg chart-card"
                                    style={{
                                        transition: "transform 0.25s ease, box-shadow 0.25s ease",
                                        minHeight: "400px",
                                    }}
                                >
                                    <div className="card-header bg-white border-0 pb-1">
                                        <h6 className="font-weight-bold text-success mb-1 text-center">
                                            {section.report_type}
                                        </h6>
                                        <p className="text-muted small text-center mb-0">
                                            Parameter: {result.parameter}
                                        </p>
                                    </div>
                                    <div
                                        className="card-body d-flex align-items-center justify-content-center"
                                        style={{ height: "320px" }}
                                    >
                                        <div className="w-100" style={{ height: "260px" }}>
                                            <Bar data={chartData} options={chartOptions} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    render() {
        const { loading, error } = this.state;

        return (
            <>
                <DashboardHeader />
                <div id="wrapper">
                    <DashboardSidebar />
                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <ol className="breadcrumb dashbread">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/reporting/dashboard">Reporting</Link>
                                </li>
                                <li className="breadcrumb-item active">Analysis</li>
                            </ol>
                            <div className="container-fluid container-dashboard">
                                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                                    <h5 className="heading text-dark font-weight-bold mb-2">
                                        Reporting Analysis
                                    </h5>

                                    <Link
                                        to="/reporting/dashboard"
                                        className="btn btn-sm text-white shadow-sm mb-2"
                                        style={{
                                            background: "#1232c3",
                                            borderRadius: "4px",
                                            fontWeight: 500,
                                            marginTop: '1rem'
                                        }}
                                    >
                                        <i className="fas fa-arrow-left mr-1"></i> Back to Dashboard
                                    </Link>
                                </div>

                                {loading ? (
                                    <div className="text-center mt-5">
                                        <div className="spinner-border text-primary" role="status"></div>
                                        <p className="mt-2 text-muted">Loading parameters...</p>
                                    </div>
                                ) : error ? (
                                    <div className="alert alert-danger text-center shadow-sm">{error}</div>
                                ) : (
                                    <>
                                        {this.renderFilters()}
                                        {this.renderCharts()}
                                    </>
                                )}
                            </div>

                        </div>
                        <FooterComponent />
                    </div>
                </div>
            </>
        );
    }
}

export default ReportingAnalysis;
